module.exports = __webpack_public_path__ + "assets/img/user.9f469d0b.svg";